module.exports = __webpack_public_path__ + "static/media/Benifits6.30e946d1.webp";